<template>
    <!-- >>> The Flight - Row -->
    <div class="details col-xs-9 col-sm-10">
        <!-- >>> The Flight - Row -->
        <div class="details-wrapper">
            <!-- >>> First Row, 'Booking', 'Services' -->
            <sdr-shared-fsr-flight-firstrow-booking  v-if="modulo === 'booking'"  :flight="flight" :flightdirection="flightdirection" :modulo="modulo"></sdr-shared-fsr-flight-firstrow-booking>
            <sdr-shared-fsr-flight-firstrow-services v-if="modulo === 'services'" :flight="flight" :flightdirection="flightdirection" :modulo="modulo"></sdr-shared-fsr-flight-firstrow-services>
            <!-- <<< First Row, 'Booking', 'Services' -->


            <!-- >>> Second Row -->
            <sdr-shared-fsr-flight-secondrow-booking  v-if="modulo === 'booking'"  :flight="flight" :flightdirection="flightdirection" :modulo="modulo"></sdr-shared-fsr-flight-secondrow-booking>
            <sdr-shared-fsr-flight-secondrow-services v-if="modulo === 'services'" :flight="flight" :flightdirection="flightdirection" :modulo="modulo"></sdr-shared-fsr-flight-secondrow-services>
            <!-- <<< Second Row -->
        </div>
        <!-- <<< The Flight - Row -->

        <!-- >>> Taxes - Row, 'Booking' only -->
        <div v-if="modulo === 'booking' && flight.prcs[0] !== undefined && flight.warn === ''" class="row" style="margin-bottom: 0px;">
            <sdr-shared-fsr-flight-taxesandfees :flight="flight" :flightdirection="flightdirection" :modulo="modulo"></sdr-shared-fsr-flight-taxesandfees>
        </div>
        <!-- <<< Taxes - Row, 'Booking' only -->
    </div>
    <!-- <<< The Flight - Row -->
</template>

<script>
    import FirstRowBooking from './firstrow/FirstRowBooking.vue';
    import FirstRowServices from './firstrow/FirstRowServices.vue';
    import SecondRowBooking from './secondrow/SecondRowBooking.vue';
    import SecondRowServices from './secondrow/SecondRowServices.vue';
    import TaxesAndFees from './TaxesAndFees.vue';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['flight', 'flightdirection', 'modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-fsr-flight-firstrow-booking': FirstRowBooking, // fsr=>flight search results
            'sdr-shared-fsr-flight-firstrow-services': FirstRowServices,
            'sdr-shared-fsr-flight-secondrow-booking': SecondRowBooking,
            'sdr-shared-fsr-flight-secondrow-services': SecondRowServices,

            'sdr-shared-fsr-flight-taxesandfees': TaxesAndFees,

        }, // eo components
        /* <<< ****************************************************************/

    };
</script>




// WEBPACK FOOTER //
// src/components/shared/flightsearch/components/fsr/Flight.vue